<div class="mt-5 centered">
    <ul class="list-group">
        <!-- <app-pull-to-refresh (onPull)="reloadList()" [refresh]="isInProgress"> -->

            <app-ref-paginator (reloadRequested)="reloadList()"></app-ref-paginator>
            <app-ref-filter (reloadRequested)="reloadList()"></app-ref-filter>
            <div class="input-group mt-3">
                <button type="button" class="btn btn-outline-success" (click)="exportService.exportRef(refills_list)">
                    <i class="fas fa-file-excel"></i></button>
                <input type="text" class="form-control" aria-label="filtro" disabled
                       [ngModel]="'Export dei rifornimenti in xls'">
            </div>

            <div *ngIf="refills_list?.length == 0" style="display: inline-flex; width: 100%;" class="mt-3 mb-1">

                <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning"
                    [style.width]="'100%'">
                    Lista vuota. {{authService.is_admin() ?
                    'Non sono state registrate ricariche per le autovetture appartenenti ' +
                    'ai parchi mezzi a te assegnati. Verifica di avere dei parchi mezzi assegnati.' :
                    'Non hai effettuato ancora nessun rifornimento.'}}
                </li>
            </div>


            <div *ngFor="let refuel of refills_list" style="display: inline-flex; width: 100%;" class="mt-3 mb-1">

                <li class="list-group-item d-flex justify-content-between align-items-center"
                    [style.width]="authService.is_admin() ? '70%' : '85%'"
                    [class.list-group-item-success]='refuel.status.id == 3'
                    [class.list-group-item-danger]='refuel.status.id == 2'
                    [class.list-group-item-pending]='refuel.status.id == 1'>
                    <span *ngIf="!dom_elements.small_screen" class="oi "
                          [class.oi-check]='refuel.status.id == 3'
                          [class.oi-ban]='refuel.status.id == 2'
                          [class.oi-clock]='refuel.status.id == 1'></span>
                    <b>#{{ refuel.id }}</b>
                    {{ refuel.travel.user.name }} <br>
                    {{ refuel.travel.user.surname }} <br>
                    {{ refuel.travel.vehicle.plate}} <br>
                    {{ refuel.kilometers}} Km<br>
                    {{dateHandler.formatDateClassic(refuel.made_at)}} <br>
                    {{dateHandler.formatTimeClassic(refuel.made_at)}}
                    <span class="badge badge-primary badge-pill badge-padding">{{refuel.amount}}€
                        <br> - <br> {{refuel.quantity}}lt </span>
                </li>

                <div style="width:15%; display:grid;">
                    <button type="button" class="btn btn-outline-info" (click)="openFotoDialog(refuel, template)"
                            tooltip="Vedi foto cruscotto/ricevuta" placement="right">
                        <span class="oi oi-image"></span>
                    </button>
                </div>

                <div *ngIf="authService.is_admin()" style="width:15%; display:grid;">

                    <div *ngIf="refuel.status.id == 1;then apr_rem else rest"></div>

                    <ng-template #apr_rem>
                        <button type="button" class="btn btn-outline-success" (click)="approveRefill(refuel)"
                                tooltip="Approva rifornimento" placement="right">
                            <span class="oi oi-check"></span>
                        </button>
                        <button type="button" class="btn btn-outline-danger" (click)="declineRefill(refuel)"
                                tooltip="Rifiuta rifornimento" placement="right">
                            <span class="oi oi-ban"></span>
                        </button>
                    </ng-template>

                    <ng-template #rest>
                        <button type="button" class="btn btn-outline-classic" (click)="restoreRefill(refuel)"
                                tooltip="Ritorna in attesa di approvazione" placement="right">
                            <span class="oi oi-clock"></span>
                        </button>
                    </ng-template>


                </div>

            </div>
        <!-- </app-pull-to-refresh> -->
    </ul>

    <ng-template #template>
        <div class="modal-header">
            <h5 class="modal-title">{{picModal.title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="picContainer mb-3">
                <img [src]="picModal.pic1">
                <p>Foto ricevuta</p>
            </div>

            <div class="picContainer mb-3">
                <img [src]="picModal.pic2">
                <p>Foto cruscotto</p>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalRef.hide()">
                Chiudi
            </button>
        </div>
    </ng-template>
</div>
